const Tours = [
  {
    'id': '1',
    'name': 'Capitol Tour',
    'img': 'https://source.unsplash.com/TRkDaJGK2yE',
    'description': 'lorem ipsumhkjgsfdbkjh vdbhudi',
    'city': 'Washington',
    'state': 'DC',
    'max_tourists': '2',
    'policies': 'Check-in 30 minutes before tour start',
    'guide_username': 'michaelanokyej@yahoo.com',
    'guide_id': 1
  },
  {
    'id': '2',
    'name': 'DC Tour',
    'img': 'https://source.unsplash.com/RJogiATgkcg',
    'description': 'lorem ipsumhkjgsfdbkjh vdbhudi',
    'city': 'Washington',
    'state': 'DC',
    'max_tourists': '10',
    'policies': 'Check-in flexible',
    'guide_username': 'michaelanokyej@yahoo.com',
    'guide_id': 1
  },
  {
    'id': '3',
    'name': 'National Mall Tour',
    'img': 'https://source.unsplash.com/ra3oAd6hrnM',
    'description': 'lorem ipsumhkjgsfdbkjh vdbhudi',
    'city': 'Washington',
    'state': 'DC',
    'max_tourists': '1',
    'policies': 'Check-in 30 minutes before tour start',
    'guide_username': 'michaelanokyej@yahoo.com',
    'guide_id': 1
  }
]

export default Tours;
